const autoNgTemplateLoaderTemplate1 = require('./servicesDatatable.html');

angular.module('portainer.docker').component('servicesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'ServicesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    nodes: '<',
    agentProxy: '<',
    showUpdateAction: '<',
    showAddAction: '<',
    showStackColumn: '<',
    showTaskLogsButton: '<',
    refreshCallback: '<',
    notAutoFocus: '<',
    endpointPublicUrl: '<',
    endpointId: '<',
  },
});
